<template>
  <FullPageNotice data-testid="license-expired-overlay">
    <div
      class="mb-4 flex items-center gap-3 text-[36px] font-semibold leading-tight text-red-additional"
    >
      <AlertIcon class="h-10 w-10" />
      <span>{{ t("license.modal.attention") }}</span>
    </div>
    <h1
      class="mb-4 text-center text-[28px] font-semibold leading-[36px] text-white-primary"
    >
      {{ t("license.expired.subtitle") }}
    </h1>
    <p
      class="mb-8 text-center text-[18px] font-normal leading-[150%] text-gray-primary"
    >
      {{ t("license.expired.description") }}
    </p>
    <a
      v-if="contactEmail"
      data-testid="license-contact-support"
      :href="mailtoHref"
      class="w-2/3 rounded-md bg-white-primary px-4 py-2.5 text-center text-button-primary text-black-primary transition-opacity hover:opacity-90"
    >
      {{ t("license.contact_support") }}
    </a>
    <button
      type="button"
      data-testid="license-expired-logout"
      class="mt-3 text-text-secondary text-gray-primary underline"
      @click="logout"
    >
      {{ t("auth.logout") }}
    </button>
  </FullPageNotice>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { Locales, MessageSchema } from "@/i18n";
import { storeToRefs } from "pinia";
import FullPageNotice from "@/components/overlays/FullPageNotice.vue";
import AlertIcon from "@/icons/alert.svg";
import { useLicenseStore } from "@/stores/settings/license";
import { useAuthStore } from "@/stores/auth/session";
import { buildSupportMailto } from "@/utils/licenseSupport";

const { t } = useI18n<{ message: MessageSchema }, Locales>();

const licenseStore = useLicenseStore();
const { contactEmail } = storeToRefs(licenseStore);

const mailtoHref = computed(() => buildSupportMailto(contactEmail.value));

const authStore = useAuthStore();
function logout() {
  authStore.logout({ redirectToLogin: true });
}
</script>
